import React, { createContext, useContext, useState } from 'react';

/**
 * SidebarContext
 *
 * Provides shared state for sidebar collapse across admin components.
 * Used to sync AdminSidebar collapse state with Settings page.
 */
const SidebarContext = createContext(null);

export function SidebarProvider({ children, defaultOpen = true }) {
  const [isCollapsed, setIsCollapsed] = useState(!defaultOpen);

  const collapse = () => setIsCollapsed(true);
  const expand = () => setIsCollapsed(false);
  const toggle = () => setIsCollapsed(prev => !prev);

  return (
    <SidebarContext.Provider value={{ isCollapsed, setIsCollapsed, collapse, expand, toggle, hasProvider: true }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    // Return default values if not wrapped in provider (for standalone usage)
    return {
      isCollapsed: false,
      setIsCollapsed: () => {},
      collapse: () => {},
      expand: () => {},
      toggle: () => {},
      hasProvider: false
    };
  }
  return context;
}

export default SidebarContext;
